export var ParserRulesHubPageSubjects;
(function (ParserRulesHubPageSubjects) {
    ParserRulesHubPageSubjects["Page"] = "parser-rules-hub-page";
    ParserRulesHubPageSubjects["Table"] = "parser-rules-hub-table";
    ParserRulesHubPageSubjects["TableEmptyState"] = "parser-rules-hub-table-empty-state";
    ParserRulesHubPageSubjects["CreateNewRuleButton"] = "parser-rules-hub-create-new-rule-button";
    ParserRulesHubPageSubjects["RowActionsButton"] = "parser-rules-hub-row-actions-button";
    ParserRulesHubPageSubjects["ActiveRuleToggle"] = "parser-rules-hub-active-toggle";
    ParserRulesHubPageSubjects["InpsectRuleButton"] = "parser-rules-hub-inspect-rule-button";
    ParserRulesHubPageSubjects["DeleteRuleButton"] = "parser-rules-hub-delete-rule-button";
    ParserRulesHubPageSubjects["DeleteRuleModal"] = "parser-rules-hub-delete-rule-modal";
    ParserRulesHubPageSubjects["ViewRuleButton"] = "parser-rules-hub-view-rule-button";
    ParserRulesHubPageSubjects["EditRuleButton"] = "parser-rules-hub-edit-rule-button";
})(ParserRulesHubPageSubjects || (ParserRulesHubPageSubjects = {}));
export var ParserRuleFormSubjects;
(function (ParserRuleFormSubjects) {
    ParserRuleFormSubjects["Page"] = "parser-rule-form-page";
    ParserRuleFormSubjects["RuleNameInput"] = "parser-rule-form-name-input";
    ParserRuleFormSubjects["RuleLogTypeInput"] = "parser-rule-form-log-type-input";
    ParserRuleFormSubjects["RuleLogSampleEditor"] = "parser-rule-form-log-sample-editor";
    ParserRuleFormSubjects["RuleBuilderEditor"] = "parser-rule-form-rule-builder-editor";
    ParserRuleFormSubjects["RulePreviewButton"] = "parser-rule-form-preview-button";
    ParserRuleFormSubjects["RulePreviewOutputEditor"] = "parser-rule-form-preview-output-editor";
    ParserRuleFormSubjects["RuleSaveButton"] = "parser-rule-form-save-button";
    ParserRuleFormSubjects["ValidationNotification"] = "parser-rule-form-validation-notification";
    ParserRuleFormSubjects["PreviewNotification"] = "parser-rule-form-preview-notification";
})(ParserRuleFormSubjects || (ParserRuleFormSubjects = {}));
//# sourceMappingURL=parser-rules.js.map